import GrupoEmail from '../../../../assets/icons/grupo_email.svg';
import Usuarios from '../../../../assets/icons/usuarios.svg';
import UsuariosExcluidos from '../../../../assets/icons/usuarios_excluidos.svg';
import Licensas from '../../../../assets/icons/licencas.svg';
import Atendimentos from '../../../../assets/icons/atendimento.svg';
import Suporte from '../../../../assets/icons/suporte.svg';
import M365 from '../../../../assets/icons/ouro.svg';
import Nuvem from '../../../../assets/icons/nuvem.svg';
import OnPremise from '../../../../assets/icons/onPremise.svg';
import Compliance from '../../../../assets/icons/compliance.svg';
import Dispositivos from '../../../../assets/icons/dispositivos.svg';
import SuportePremium from '../../../../assets/icons/suporte_premium.svg';
import Outsourcing from '../../../../assets/icons/outsourcing.svg';
import Servicos from '../../../../assets/icons/Solicitacao-De-Servico.svg';
import Financeiro from '../../../../assets/icons/Financeiro.svg';
import DownloadBoleto from '../../../../assets/icons/DownloadBoleto.svg';
import DownloadExtrato from '../../../../assets/icons/DownloadExtrato.svg';
import DownloadRps from '../../../../assets/icons/DownloadRps.svg';
import DownloadXML from '../../../../assets/icons/DownloadXML.svg';
import DownloadNFS from '../../../../assets/icons/DownloadNFS.svg';
import AtualizarBoleto from '../../../../assets/icons/AtualizarBoleto.svg';
import Grupos from '../../../../assets/icons/Grupos.svg';
import Default from '../../../../assets/icons/default.svg'
import UsuarioRestaurar from '../../../../assets/icons/usuario_restaurar.svg'

export default function returnIcons (iconName) {
  return iconMap[iconName] || Default;
}

const iconMap = {
  'icon-grupo-email': GrupoEmail,
  'icon-licensas': Licensas,
  'icon-user': Usuarios,
  'icon-usuarios-excluidos': UsuariosExcluidos,
  'icon-atendimentos': Atendimentos,
  'icon-preciso-suporte': Suporte,
  'icon-m365': M365,
  'icon-nuvem': Nuvem,
  'icon-compliance': Compliance,
  'icon-onpremise': OnPremise,
  'icon-dispositivos': Dispositivos,
  'icon-outsourcing': Outsourcing,
  'icon-suporte-premium': SuportePremium,
  'icon-preciso-servico': Servicos,
  'icon-suporte': Suporte  ,
  'icon-financeiro': Financeiro  ,
  'icon-download-boleto': DownloadBoleto,
  'icon-download-extrato': DownloadExtrato,
  'icon-download-rps': DownloadRps,
  'icon-download-xml': DownloadXML,
  'icon-download-nfs': DownloadNFS,
  'icon-atualizar-boleto': AtualizarBoleto,
  'icon-grupo': Grupos,
  'icon-usuario-restaurar': UsuarioRestaurar,
}